export const FINDER_POSITIONS = [
  { row: 0, col: 0 },
  { row: 0, col: -7 },
  { row: -7, col: 0 },
] as const;
